// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11uLH","footer":"styles_footer__2kkLV","passCodeTooltip":"styles_passCodeTooltip__7F7O1"};